import React from 'react';
import { EffectComposer, Bloom } from '@react-three/postprocessing';
import { BlendFunction, KernelSize } from 'postprocessing';

function PostProcessing() {
  return (
    <EffectComposer>
      <Bloom 
        intensity={1.5}
        luminanceThreshold={0.1}
        luminanceSmoothing={0.9}
        blendFunction={BlendFunction.SCREEN}
        kernelSize={KernelSize.LARGE}
      />
    </EffectComposer>
  );
}

export default PostProcessing;